/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `MARKETPLACE` - Created from the marketplace app
 * * `HIRE` - Created from the Hire Candidates page (organizational; no automatic dispatch)
 */
export type FavoriteGroupSourceEnum = typeof FavoriteGroupSourceEnum[keyof typeof FavoriteGroupSourceEnum];


export const FavoriteGroupSourceEnum = {
  MARKETPLACE: 'MARKETPLACE',
  HIRE: 'HIRE',
} as const;
